"use strict";

Shopify.theme.jsPaymentDetails = {
  init: function init($json) {
    if($json.customer.id){
    	this.getCCInfo($json.customer.id);
    }
    this.pageid = $json.pageID;
    
  },
  getCCInfo: function(customerID){
    
    $.ajax({
      type: 'GET',
      url: 'https://zoho.mrgrien.com/apps/mrgreen/functions/getccinfo.cfm?customerid=' + customerID ,
      success: $.proxy(this.renderResults,this),
      error: function(e){console.log(e)},
	});
  	
  },
  renderResults: function renderResults(results){
  	var $pageSection = $('.page-' + this.pageid),
        $creditCard = $pageSection.find('.payment-option-creditcard')
    
    // only update the values if the customer has a creditcard 
    if(results.cctype && results.ccnumber && results.ccexp){
    	$creditCard.find('.payment-type').html(results.cctype + ' ' + results.ccnumber);
   		$creditCard.find('.details').html('Ablaufdatum ' + results.ccexp);
    } else {
      $creditCard.hide();
    }
    $('#payment-methods-placeholder',$pageSection).hide();
    $('#payment-methods',$pageSection).show();
    
  },
  unload: function unload($section) {}
};
